import { z } from 'zod';
import { idSchema, isoDateTimeSchema, tenantIdSchema } from './common.schema';
/**
 * Audit log entry — every write-path action (Desk audit pattern).
 * Immutable: no updates or deletes.
 */
export const AUDIT_ACTIONS = [
    'CREATE',
    'UPDATE',
    'DELETE',
    'EXPORT',
    'TOKEN_ISSUED',
    'TOKEN_REVOKED',
    'REGISTER',
    'ACKNOWLEDGE',
    'RESOLVE',
];
export const auditActorSchema = z
    .object({
    userId: idSchema,
    email: z.string().max(320),
    displayName: z.string().max(200),
    /** How the actor authenticated. */
    authSource: z.enum(['firebase', 'api_token', 'collector', 'system']),
    /** Set when the action was taken under a cross-tenant management grant (#16): the actor
     *  signed in to `tenantId` and acted in THIS entry's tenant through `delegationId`. */
    delegatedFrom: z
        .object({ tenantId: tenantIdSchema, delegationId: z.string().min(1).max(300) })
        .strict()
        .optional(),
})
    .strict();
export const auditLogSchema = z
    .object({
    tenantId: tenantIdSchema,
    module: z.string().min(1).max(64),
    entityType: z.string().min(1).max(64),
    entityId: z.string().min(1).max(256),
    action: z.enum(AUDIT_ACTIONS),
    actor: auditActorSchema,
    changes: z
        .object({
        before: z.record(z.unknown()).nullable(),
        after: z.record(z.unknown()).nullable(),
    })
        .strict()
        .optional(),
    metadata: z.record(z.unknown()).optional(),
    createdAt: isoDateTimeSchema,
})
    .strict();
//# sourceMappingURL=audit.schema.js.map